export const COMPANY_TAB = {
  VALIDATION: {
    MISSING_INFO_TITLE: "Missing Information",
    MISSING_INFO_MESSAGE: "Please fill out all required fields to create the Company.",
  },
  DIALOGS: {

    CONFIRM_CREATE_TITLE: "Confirm Create",
    CONFIRM_CREATE_MESSAGE: "Are you sure you want to create this Company?",

    CONFIRM_EDIT_TITLE: "Confirm Edit",
    CONFIRM_EDIT_MESSAGE: "Are you sure you want to save the changes to this company?",

    CONFIRM_NEW_TITLE: "Create New Company",
    CONFIRM_NEW_MESSAGE: "Are you sure you want to clear the form and create a new Company?",
  }
};

export const ASSET_TAB = {
  VALIDATION: {
      MISSING_INFO_TITLE: "Missing Information",
      MISSING_INFO_MESSAGE: "Please fill out all required fields to create the Asset.",
    },
    DIALOGS: {

      CONFIRM_CREATE_TITLE: "Confirm Create",
      CONFIRM_CREATE_MESSAGE: "Are you sure you want to create this Asset?",
  
      CONFIRM_EDIT_TITLE: "Confirm Edit",
      CONFIRM_EDIT_MESSAGE: "Are you sure you want to save the changes to this asset?",
  
      CONFIRM_NEW_TITLE: "Create New Asset",
      CONFIRM_NEW_MESSAGE: "Are you sure you want to clear the form and create a new asset ?",
    }
};
export const METRIC_TAB = {
  VALIDATION: {
      MISSING_INFO_TITLE: "Missing Information",
      MISSING_INFO_MESSAGE: "Please fill out all required fields to create the Metric.",
    },
    DIALOGS: {

      CONFIRM_CREATE_TITLE: "Confirm Create",
      CONFIRM_CREATE_MESSAGE: "Are you sure you want to create this Metric?",
  
      CONFIRM_EDIT_TITLE: "Confirm Edit",
      CONFIRM_EDIT_MESSAGE: "Are you sure you want to save the changes to this metric?",
  
      CONFIRM_NEW_TITLE: "Create New Metric",
      CONFIRM_NEW_MESSAGE: "Are you sure you want to clear the form and create a new metric ?",
    }
};
export const PARTICIPANT_TAB = {
  VALIDATION: {
      MISSING_INFO_TITLE: "Missing Information",
      MISSING_INFO_MESSAGE: "Please fill out all required fields to create the participant.",
    },
    DIALOGS: {

      CONFIRM_CREATE_TITLE: "Confirm Create",
      CONFIRM_CREATE_MESSAGE: "Are you sure you want to create this participant?",
  
      CONFIRM_EDIT_TITLE: "Confirm Edit",
      CONFIRM_EDIT_MESSAGE: "Are you sure you want to save the changes to this participant?",
  
      CONFIRM_NEW_TITLE: "Create New Participant",
      CONFIRM_NEW_MESSAGE: "Are you sure you want to clear the form and create a new participant ?",
    }
};
export const RESOURCE_TAB = {
  VALIDATION: {
      MISSING_INFO_TITLE: "Missing Information",
      MISSING_INFO_MESSAGE: "Please fill out all required fields to create the Resource.",
    },
    DIALOGS: {

      CONFIRM_CREATE_TITLE: "Confirm Create",
      CONFIRM_CREATE_MESSAGE: "Are you sure you want to create this Resource?",
  
      CONFIRM_EDIT_TITLE: "Confirm Edit",
      CONFIRM_EDIT_MESSAGE: "Are you sure you want to save the changes to this Resource?",
  
      CONFIRM_NEW_TITLE: "Create New Resource",
      CONFIRM_NEW_MESSAGE: "Are you sure you want to clear the form and create a new Resource ?",
    }
};
export const ASSETGROUP_TAB = {
  VALIDATION: {
      MISSING_INFO_GROUP_TITLE: "Missing Group Name",
      MISSING_INFO_GROUP_MESSAGE:  "Please enter a name for the asset group.",

      MISSING_INFO_TITLE: "No Assets Selected",
      MISSING_INFO_MESSAGE:  "Please select at least one asset before proceeding.",
    },
    DIALOGS: {

      CONFIRM_CREATE_TITLE: "Confirm Create",
      CONFIRM_CREATE_MESSAGE: "Are you sure you want to create this asset group?",
  
      CONFIRM_EDIT_TITLE: "Confirm Edit",
      CONFIRM_EDIT_MESSAGE: "Are you sure you want to save the changes to this asset group?",
  
      CONFIRM_NEW_TITLE: "Create New Asset Group",
      CONFIRM_NEW_MESSAGE: "Are you sure you want to clear the form and create a new asset group ?",
    }
};
export const METRICGROUP_TAB = {
  VALIDATION: {
      MISSING_INFO_GROUP_TITLE: "Missing Group Name",
      MISSING_INFO_GROUP_MESSAGE:  "Please enter a name for the metric group.",

      MISSING_INFO_TITLE: "No Metrics Selected",
      MISSING_INFO_MESSAGE:  "Please select at least one metric before proceeding.",
    },
    DIALOGS: {

      CONFIRM_CREATE_TITLE: "Confirm Create",
      CONFIRM_CREATE_MESSAGE: "Are you sure you want to create this metric group?",
  
      CONFIRM_EDIT_TITLE: "Confirm Edit",
      CONFIRM_EDIT_MESSAGE: "Are you sure you want to save the changes to this metric group?",
  
      CONFIRM_NEW_TITLE: "Create New Metric Group",
      CONFIRM_NEW_MESSAGE: "Are you sure you want to clear the form and create a new metric group ?",
    }
};
export const USERGROUP_TAB = {
  VALIDATION: {
      MISSING_INFO_GROUP_TITLE: "Missing Role Name",
      MISSING_INFO_GROUP_MESSAGE:  "Please enter a name for the role.",

      MISSING_INFO_TITLE: "No Users Selected",
      MISSING_INFO_MESSAGE:  "Please select at least one user before proceeding.",
    },
    DIALOGS: {

      CONFIRM_CREATE_TITLE: "Confirm Create",
      CONFIRM_CREATE_MESSAGE: "Are you sure you want to create this role?",
  
      CONFIRM_EDIT_TITLE: "Confirm Edit",
      CONFIRM_EDIT_MESSAGE: "Are you sure you want to save the changes to this role?",
  
      CONFIRM_NEW_TITLE: "Create New Role",
      CONFIRM_NEW_MESSAGE: "Are you sure you want to clear the form and create a new role?",
    }
};
export const OUTAGE_TAB = {
  VALIDATION: {
      MISSING_INFO_TITLE: "Missing Information",
      MISSING_INFO_MESSAGE: "Please fill out all required fields to Submit the Outage.",
    },
    DIALOGS: {

      CONFIRM_CREATE_TITLE: "Confirm Create",
      CONFIRM_CREATE_MESSAGE: "Are you sure you want to create this Outage?",
  
      CONFIRM_EDIT_TITLE: "Confirm Edit",
      CONFIRM_EDIT_MESSAGE: "Are you sure you want to save the changes to this Outage?",
  
      CONFIRM_NEW_TITLE: "Create New Outage",
      CONFIRM_NEW_MESSAGE: "Are you sure you want to clear the form and create a new Outage?",
    },
    UPCOMING: {
      UPCOMING_INFO_TITLE: "Upcoming Outages",
      UPCOMING_INFO_MESSAGE: "Copied Outages with upcoming Start or End with 13 Hours.",
    }
};